import icon1InCircle from './1-in-circle.svg?raw';
import icon2InCircle from './2-in-circle.svg?raw';
import icon3InCircle from './3-in-circle.svg?raw';
import icon50Progress from './50-progress.svg?raw';
import icon75Progress from './75-progress.svg?raw';
import aInCircle from './a-in-circle.svg?raw';
import addCalendar from './add-calendar.svg?raw';
import addInCircle from './add-in-circle.svg?raw';
import add from './add.svg?raw';
import airplane2 from './airplane-2.svg?raw';
import airplane from './airplane.svg?raw';
import arrowDownInCircle2 from './arrow-down-in-circle-2.svg?raw';
import arrowDownInCircle from './arrow-down-in-circle.svg?raw';
import arrowDown from './arrow-down.svg?raw';
import arrowLeft2 from './arrow-left-2.svg?raw';
import arrowLeftInCircle2 from './arrow-left-in-circle-2.svg?raw';
import arrowLeftInCircle from './arrow-left-in-circle.svg?raw';
import arrowLeft from './arrow-left.svg?raw';
import arrowRightBlack from './arrow-right-black.svg?raw';
import arrowRightBlue from './arrow-right-blue.svg?raw';
import arrowRightInBubble from './arrow-right-in-bubble.svg?raw';
import arrowRightInCircle2 from './arrow-right-in-circle-2.svg?raw';
import arrowRightInCircle from './arrow-right-in-circle.svg?raw';
import arrowRightWhite from './arrow-right-white.svg?raw';
import arrowRight from './arrow-right.svg?raw';
import arrowRigth2 from './arrow-rigth-2.svg?raw';
import arrowRigth from './arrow-rigth.svg?raw';
import arrowUpInCircle2 from './arrow-up-in-circle-2.svg?raw';
import arrowUpInCircle from './arrow-up-in-circle.svg?raw';
import arrowUp from './arrow-up.svg?raw';
import attach from './attach.svg?raw';
import attentionBlack from './attention-black.svg?raw';
import attentionInBubble from './attention-in-bubble.svg?raw';
import attentionInTriangle from './attention-in-triangle.svg?raw';
import attentionWhite from './attention-white.svg?raw';
import attention from './attention.svg?raw';
import bInCircle from './b-in-circle.svg?raw';
import bookmark from './bookmark.svg?raw';
import box from './box.svg?raw';
import brightness from './brightness.svg?raw';
import brokenHeart from './broken-heart.svg?raw';
import calendarAdd from './calendar-add.svg?raw';
import calendar from './calendar.svg?raw';
import callIncoming from './call-incoming.svg?raw';
import callOutgoing from './call-outgoing.svg?raw';
import call from './call.svg?raw';
import cameraOff from './camera-off.svg?raw';
import camera from './camera.svg?raw';
import card from './card.svg?raw';
import change from './change.svg?raw';
import chat from './chat.svg?raw';
import checkInCircle from './check-in-circle.svg?raw';
import checkLabel from './check-label.svg?raw';
import checkboxIndeterminate from './checkbox-indeterminate.svg?raw';
import checkbox from './checkbox.svg?raw';
import chrome from './chrome.svg?raw';
import closeInCircle from './close-in-circle.svg?raw';
import close from './close.svg?raw';
import code from './code.svg?raw';
import comeback from './comeback.svg?raw';
import contacts from './contacts.svg?raw';
import continueIcon from './continue.svg?raw';
import copy from './copy.svg?raw';
import courses from './courses.svg?raw';
import crown from './crown.svg?raw';
import defaultIcon from './default.svg?raw';
import display from './display.svg?raw';
import division from './division.svg?raw';
import docs from './docs.svg?raw';
import doneInFlag from './done-in-flag.svg?raw';
import done from './done.svg?raw';
import doubleCheck from './double-check.svg?raw';
import downloadInSquare from './download-in-square.svg?raw';
import download from './download.svg?raw';
import dropdownInline from './dropdown-inline.svg?raw';
import dropdownUp from './dropdown-up.svg?raw';
import dropdown from './dropdown.svg?raw';
import effects from './effects.svg?raw';
import experience1 from './experience-1.svg?raw';
import experience3 from './experience-3.svg?raw';
import eye from './eye.svg?raw';
import failed from './failed.svg?raw';
import favorite from './favorite.svg?raw';
import fbMessenger from './fb-messenger.svg?raw';
import fb from './fb.svg?raw';
import fire from './fire.svg?raw';
import flag from './flag.svg?raw';
import flask from './flask.svg?raw';
import folderAdd from './folder-add.svg?raw';
import folderRemove from './folder-remove.svg?raw';
import folder from './folder.svg?raw';
import forbidden from './forbidden.svg?raw';
import fullscreen from './fullscreen.svg?raw';
import gamepad from './gamepad.svg?raw';
import gif from './gif.svg?raw';
import gift from './gift.svg?raw';
import grammar from './grammar.svg?raw';
import groupOfPeople from './group-of-people.svg?raw';
import group from './group.svg?raw';
import heart from './heart.svg?raw';
import help from './help.svg?raw';
import hide from './hide.svg?raw';
import home from './home.svg?raw';
import homework from './homework.svg?raw';
import hw from './hw.svg?raw';
import image from './image.svg?raw';
import inProgress from './in-progress.svg?raw';
import info from './info.svg?raw';
import joy from './joy.svg?raw';
import joystick from './joystick.svg?raw';
import key from './key.svg?raw';
import keyboardNumbers from './keyboard-numbers.svg?raw';
import keyboard from './keyboard.svg?raw';
import label from './label.svg?raw';
import lightning from './lightning.svg?raw';
import link from './link.svg?raw';
import list2 from './list-2.svg?raw';
import list3 from './list-3.svg?raw';
import list4 from './list-4.svg?raw';
import list from './list.svg?raw';
import listening from './listening.svg?raw';
import loader from './loader.svg?raw';
import location from './location.svg?raw';
import lock from './lock.svg?raw';
import locked from './locked.svg?raw';
import login from './login.svg?raw';
import logout2 from './logout-2.svg?raw';
import logout from './logout.svg?raw';
import messageWithNotification from './message-with-notification.svg?raw';
import message from './message.svg?raw';
import microphoneOff from './microphone-off.svg?raw';
import microphone from './microphone.svg?raw';
import minus from './minus.svg?raw';
import mobileDownload from './mobile-download.svg?raw';
import mobile from './mobile.svg?raw';
import moreInCircle from './more-in-circle.svg?raw';
import more from './more.svg?raw';
import neutalFace from './neutal-face.svg?raw';
import newIcon from './new.svg?raw';
import notebookUpload from './notebook-upload.svg?raw';
import notebook from './notebook.svg?raw';
import notification2 from './notification-2.svg?raw';
import notification from './notification.svg?raw';
import num from './num.svg?raw';
import open from './open.svg?raw';
import paragraphBulletList from './paragraph-bullet-list.svg?raw';
import paragraphJustify from './paragraph-justify.svg?raw';
import paragraphOrderedList from './paragraph-ordered-list.svg?raw';
import paragraphRight from './paragraph-right.svg?raw';
import pauseInCircle from './pause-in-circle.svg?raw';
import peopleAdd from './people-add.svg?raw';
import peopleRemove from './people-remove.svg?raw';
import photo from './photo.svg?raw';
import pinWithTime from './pin-with-time.svg?raw';
import pin from './pin.svg?raw';
import playInCircle from './play-in-circle.svg?raw';
import play from './play.svg?raw';
import portfolio from './portfolio.svg?raw';
import practice from './practice.svg?raw';
import profile from './profile.svg?raw';
import projector from './projector.svg?raw';
import pronunciation from './pronunciation.svg?raw';
import questionInCircle from './question-in-circle.svg?raw';
import reading from './reading.svg?raw';
import refresh from './refresh.svg?raw';
import removeInCircle from './remove-in-circle.svg?raw';
import results from './results.svg?raw';
import sInCircle from './s-in-circle.svg?raw';
import sad from './sad.svg?raw';
import safari from './safari.svg?raw';
import screenScaleDown2 from './screen-scale-down-2.svg?raw';
import screenScaleDown from './screen-scale-down.svg?raw';
import screenScaleUp2 from './screen-scale-up-2.svg?raw';
import screenScaleUp from './screen-scale-up.svg?raw';
import screenSharingFill from './screen-sharing-fill.svg?raw';
import screenSharing from './screen-sharing.svg?raw';
import searchPerson from './search-person.svg?raw';
import settings2 from './settings-2.svg?raw';
import settings from './settings.svg?raw';
import shield from './shield.svg?raw';
import shopBag from './shop-bag.svg?raw';
import show from './show.svg?raw';
import smile from './smile.svg?raw';
import snowflake from './snowflake.svg?raw';
import sparcle from './sparcle.svg?raw';
import sprint from './sprint.svg?raw';
import statsInCircle from './stats-in-circle.svg?raw';
import statsInSquare from './stats-in-square.svg?raw';
import stats from './stats.svg?raw';
import steps from './steps.svg?raw';
import stop from './stop.svg?raw';
import suitcase from './suitcase.svg?raw';
import surprise from './surprise.svg?raw';
import switchIcon from './switch.svg?raw';
import tInCircle from './t-in-circle.svg?raw';
import talks from './talks.svg?raw';
import target2 from './target-2.svg?raw';
import target from './target.svg?raw';
import telegram from './telegram.svg?raw';
import terminal from './terminal.svg?raw';
import textInBubble from './text-in-bubble.svg?raw';
import thumbDown from './thumb-down.svg?raw';
import thumbUp from './thumb-up.svg?raw';
import timeSecondary from './time-secondary.svg?raw';
import time from './time.svg?raw';
import trashBin from './trash-bin.svg?raw';
import typingInBubble from './typing-in-bubble.svg?raw';
import unlock from './unlock.svg?raw';
import video from './video.svg?raw';
import vk from './vk.svg?raw';
import vocabulary2 from './vocabulary-2.svg?raw';
import vocabulary from './vocabulary.svg?raw';
import volumeFull from './volume-full.svg?raw';
import volumeOff from './volume-off.svg?raw';
import volume from './volume.svg?raw';
import waiting from './waiting.svg?raw';
import wallet from './wallet.svg?raw';
import whatsapp from './whatsapp.svg?raw';
import world from './world.svg?raw';
import writing2 from './writing-2.svg?raw';
import writing3 from './writing-3.svg?raw';
import writing from './writing.svg?raw';
import zoomIn from './zoom-in.svg?raw';
import zoomOut from './zoom-out.svg?raw';
import zoom from './zoom.svg?raw';

export const mediumIcons: Record<string, string> = {
  '1-in-circle': icon1InCircle,
  '2-in-circle': icon2InCircle,
  '3-in-circle': icon3InCircle,
  '50-progress': icon50Progress,
  '75-progress': icon75Progress,
  'a-in-circle': aInCircle,
  'add-calendar': addCalendar,
  'add-in-circle': addInCircle,
  add: add,
  'airplane-2': airplane2,
  airplane: airplane,
  'arrow-down-in-circle-2': arrowDownInCircle2,
  'arrow-down-in-circle': arrowDownInCircle,
  'arrow-down': arrowDown,
  'arrow-left-2': arrowLeft2,
  'arrow-left-in-circle-2': arrowLeftInCircle2,
  'arrow-left-in-circle': arrowLeftInCircle,
  'arrow-left': arrowLeft,
  'arrow-right-black': arrowRightBlack,
  'arrow-right-blue': arrowRightBlue,
  'arrow-right-in-bubble': arrowRightInBubble,
  'arrow-right-in-circle-2': arrowRightInCircle2,
  'arrow-right-in-circle': arrowRightInCircle,
  'arrow-right-white': arrowRightWhite,
  'arrow-right': arrowRight,
  'arrow-rigth-2': arrowRigth2,
  'arrow-rigth': arrowRigth,
  'arrow-up-in-circle-2': arrowUpInCircle2,
  'arrow-up-in-circle': arrowUpInCircle,
  'arrow-up': arrowUp,
  attach: attach,
  'attention-black': attentionBlack,
  'attention-in-bubble': attentionInBubble,
  'attention-in-triangle': attentionInTriangle,
  'attention-white': attentionWhite,
  attention: attention,
  'b-in-circle': bInCircle,
  bookmark: bookmark,
  box: box,
  brightness: brightness,
  'broken-heart': brokenHeart,
  'calendar-add': calendarAdd,
  calendar: calendar,
  'call-incoming': callIncoming,
  'call-outgoing': callOutgoing,
  call: call,
  'camera-off': cameraOff,
  camera: camera,
  card: card,
  change: change,
  chat: chat,
  'check-in-circle': checkInCircle,
  'check-label': checkLabel,
  'checkbox-indeterminate': checkboxIndeterminate,
  checkbox: checkbox,
  chrome: chrome,
  'close-in-circle': closeInCircle,
  close: close,
  code: code,
  comeback: comeback,
  contacts: contacts,
  continue: continueIcon,
  copy: copy,
  courses: courses,
  crown: crown,
  default: defaultIcon,
  display: display,
  division: division,
  docs: docs,
  'done-in-flag': doneInFlag,
  done: done,
  'double-check': doubleCheck,
  'download-in-square': downloadInSquare,
  download: download,
  'dropdown-inline': dropdownInline,
  'dropdown-up': dropdownUp,
  dropdown: dropdown,
  effects: effects,
  'experience-1': experience1,
  'experience-3': experience3,
  eye: eye,
  failed: failed,
  favorite: favorite,
  'fb-messenger': fbMessenger,
  fb: fb,
  fire: fire,
  flag: flag,
  flask: flask,
  'folder-add': folderAdd,
  'folder-remove': folderRemove,
  folder: folder,
  forbidden: forbidden,
  fullscreen: fullscreen,
  gamepad: gamepad,
  gif: gif,
  gift: gift,
  grammar: grammar,
  'group-of-people': groupOfPeople,
  group: group,
  heart: heart,
  help: help,
  hide: hide,
  home: home,
  homework: homework,
  hw: hw,
  image: image,
  'in-progress': inProgress,
  info: info,
  joy: joy,
  joystick: joystick,
  key: key,
  'keyboard-numbers': keyboardNumbers,
  keyboard: keyboard,
  label: label,
  lightning: lightning,
  link: link,
  'list-2': list2,
  'list-3': list3,
  'list-4': list4,
  list: list,
  listening: listening,
  loader: loader,
  location: location,
  lock: lock,
  locked: locked,
  login: login,
  'logout-2': logout2,
  logout: logout,
  'message-with-notification': messageWithNotification,
  message: message,
  'microphone-off': microphoneOff,
  microphone: microphone,
  minus: minus,
  'mobile-download': mobileDownload,
  mobile: mobile,
  'more-in-circle': moreInCircle,
  more: more,
  'neutal-face': neutalFace,
  new: newIcon,
  'notebook-upload': notebookUpload,
  notebook: notebook,
  'notification-2': notification2,
  notification: notification,
  num: num,
  open: open,
  'paragraph-bullet-list': paragraphBulletList,
  'paragraph-justify': paragraphJustify,
  'paragraph-ordered-list': paragraphOrderedList,
  'paragraph-right': paragraphRight,
  'pause-in-circle': pauseInCircle,
  'people-add': peopleAdd,
  'people-remove': peopleRemove,
  photo: photo,
  'pin-with-time': pinWithTime,
  pin: pin,
  'play-in-circle': playInCircle,
  play: play,
  portfolio: portfolio,
  practice: practice,
  profile: profile,
  projector: projector,
  pronunciation: pronunciation,
  'question-in-circle': questionInCircle,
  reading: reading,
  refresh: refresh,
  'remove-in-circle': removeInCircle,
  results: results,
  's-in-circle': sInCircle,
  sad: sad,
  safari: safari,
  'screen-scale-down-2': screenScaleDown2,
  'screen-scale-down': screenScaleDown,
  'screen-scale-up-2': screenScaleUp2,
  'screen-scale-up': screenScaleUp,
  'screen-sharing-fill': screenSharingFill,
  'screen-sharing': screenSharing,
  'search-person': searchPerson,
  'settings-2': settings2,
  settings: settings,
  shield: shield,
  'shop-bag': shopBag,
  show: show,
  smile: smile,
  snowflake: snowflake,
  sparcle: sparcle,
  sprint: sprint,
  'stats-in-circle': statsInCircle,
  'stats-in-square': statsInSquare,
  stats: stats,
  steps: steps,
  stop: stop,
  suitcase: suitcase,
  surprise: surprise,
  switch: switchIcon,
  't-in-circle': tInCircle,
  talks: talks,
  'target-2': target2,
  target: target,
  telegram: telegram,
  terminal: terminal,
  'text-in-bubble': textInBubble,
  'thumb-down': thumbDown,
  'thumb-up': thumbUp,
  'time-secondary': timeSecondary,
  time: time,
  'trash-bin': trashBin,
  'typing-in-bubble': typingInBubble,
  unlock: unlock,
  video: video,
  vk: vk,
  'vocabulary-2': vocabulary2,
  vocabulary: vocabulary,
  'volume-full': volumeFull,
  'volume-off': volumeOff,
  volume: volume,
  waiting: waiting,
  wallet: wallet,
  whatsapp: whatsapp,
  world: world,
  'writing-2': writing2,
  'writing-3': writing3,
  writing: writing,
  'zoom-in': zoomIn,
  'zoom-out': zoomOut,
  zoom: zoom,
};
